import { render } from "./areas.vue?vue&type=template&id=742ae2be&scoped=true"
import script from "./areas.vue?vue&type=script&lang=js"
export * from "./areas.vue?vue&type=script&lang=js"

import "./areas.vue?vue&type=style&index=0&id=742ae2be&scoped=true&lang=css"

import exportComponent from "D:\\Web\\hkjt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-742ae2be"]])

export default __exports__